/* eslint-disable prefer-const */
/* eslint-disable no-continue */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-explicit-any */

import IconCheckWhite from '@assets/icons/check-white.svg?react';
import {
 Box,
 Button,
 Dialog,
 DialogContent,
 Theme,
 useMediaQuery,
} from '@mui/material';
import { memo, MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { usePage } from '../../../contexts/usePageContext';
import { setConfigStorageItem } from '../../../hooks/useConfigStorage';
import { changeCurrentPreset } from '../../../redux/clientConfiguration/clientConfigurationSlice';
import { RootState } from '../../../redux/store';
import themeOptions from '../../../utils/theme';
import CloseButton from '../CloseButton';
import ModalConf from '../ModalConf';
import { CustomGridApi } from '../XTable/types';
import ColModalCols from './ColModalCols';
import ColModalCurrent from './ColModalCurrent';
import ColModalTabsResponsive from './ColModalTabsResponsive';

interface ColModalProps {
 isOpen: boolean;
 handleClose: React.Dispatch<React.SetStateAction<boolean>>;
 apiRef: MutableRefObject<CustomGridApi>;
 //  setColumnState: any;
}

const ColModal = memo((props: ColModalProps) => {
 const { pageName } = usePage();
 const { t } = useTranslation();
 const dispatch = useDispatch();
 const { isOpen, handleClose, apiRef } = props;
 const tempColumnsPreset = useSelector(
  (state: RootState) =>
   state.clientConfiguration.tempColumnsPreset?.[pageName] || null,
 );

 const updateGrid = () => {
  if (tempColumnsPreset) {
   const { filters, columns } = tempColumnsPreset;

   const sortedFilters = {
    fields: Object.keys(
     filters?.fields || tempColumnsPreset?.filters?.fields || {},
    )
     .sort((a, b) => {
      const aIndex = columns?.findIndex((column) => column.field === a) || 0;
      const bIndex = columns?.findIndex((column) => column.field === b) || 0;
      return aIndex - bIndex;
     })
     .reduce(
      (acc, curr) => {
       acc[curr] = filters?.fields?.[curr] ?? '';
       return acc;
      },
      {} as Record<
       string,
       string | number | { [key: string]: string | number }[]
      >,
     ),
    operators: Object.keys(
     filters?.operators || tempColumnsPreset?.filters?.operators || {},
    )
     .sort((a, b) => {
      const aIndex = columns?.findIndex((column) => column.field === a) || 0;
      const bIndex = columns?.findIndex((column) => column.field === b) || 0;
      return aIndex - bIndex;
     })
     .reduce(
      (acc, curr) => {
       acc[curr] = filters?.operators?.[curr] ?? '';
       return acc;
      },
      {} as Record<string, string>,
     ),
   };

   const sortedPreset = {
    name: tempColumnsPreset.name,
    columns: tempColumnsPreset.columns,
    filters: sortedFilters,
   };

   dispatch(
    changeCurrentPreset({
     page: pageName,
     type: 'columns',
     preset: sortedPreset,
     temp: false,
    }),
   );
   setConfigStorageItem({
    page: pageName,
    key: 'columns',
    value: sortedPreset,
   });

   const presetFilters = filters?.fields;
   const currentFilterModel = apiRef.current.state.filter.filterModel;

   const newItems = currentFilterModel.items.filter(
    (item) => presetFilters?.[item.field],
   );

   apiRef.current.setFilterModel(
    {
     ...currentFilterModel,
     items: newItems,
    },
    'upsertFilterItems',
   );

   handleClose(false);
  }
 };

 // Tab configuration for mobile
 const tabs = [
  {
   id: 'all-columns',
   label: t('colModal.colsAll'),
   content: <ColModalCols />,
  },
  {
   id: 'selected-columns',
   label: t('colModal.colsSelected'),
   content: <ColModalCurrent />,
  },
 ];

 const isLargerThanMd = useMediaQuery(themeOptions().breakpoints.up('md'));

 return (
  <Dialog
   open={isOpen}
   onClose={() => handleClose(false)}
   fullWidth
   fullScreen={!isLargerThanMd}
   sx={{
    '& .MuiDialog-container': {
     '& .MuiPaper-root': {
      width: '100%',
      height: '100%',
      maxWidth: '960px',
     },
    },
   }}
  >
   <CloseButton closeDialog={() => handleClose(false)} />
   <DialogContent sx={{ p: 0 }}>
    <Box
     sx={{
      display: { xs: 'flex', md: 'flex' },
      flexDirection: { xs: 'column', md: 'row' },
      fontSize: 14,
      // overflowY: { xs: 'hidden', md: 'auto' },
      minHeight: { xs: 'fit-content', md: '100%' },
      height: { xs: 'calc(100% - 160px)', md: '100%' },
     }}
    >
     {/* CURRENT COLUMNS */}
     <ModalConf />
     <Box
      sx={{
       borderLeft: (theme: Theme) => ({
        xs: 'none',
        md: `1px solid ${theme.palette.kemek.lightestGray}`,
       }),
       display: 'flex',
       flexDirection: 'column',
       px: { xs: 0, md: 3 },
       pb: { xs: 0, md: 3 },
       pt: { xs: 0, md: '67px' },
       width: '100%',
       height: '100%',
      }}
     >
      <Box sx={{ height: '100%' }}>
       {/* Desktop layout - side by side */}
       <Box
        sx={{
         display: { xs: 'none', md: 'flex' },
         gap: 3,
         height: { xs: '100%', md: 'calc(100% - 66px)' },
        }}
       >
        <ColModalCols />
        <ColModalCurrent />
       </Box>

       {/* Mobile layout - tabs */}
       <Box
        sx={{
         display: { xs: 'flex', md: 'none' },
         flexDirection: 'column',
         height: 'calc(100% - 80px)',
        }}
       >
        <Box sx={{ flex: 1, overflowY: 'hidden' }}>
         <ColModalTabsResponsive
          tabs={tabs}
          defaultTab={0}
          variant="fullWidth"
          ariaLabel={t('colModal.colSettings')}
          panelSx={{
           height: '100%',
           overflowY: 'auto',
          }}
         />
        </Box>
       </Box>

       <Box
        sx={{
         display: 'flex',
         //  display: { xs: 'none', md: 'flex' },
         justifyContent: 'flex-end',
         px: { xs: 3, md: 1 },
         py: { xs: 3, md: 3 },
         gap: 1,
        }}
       >
        <Button
         onClick={() => handleClose(false)}
         variant="outlined"
         color="secondary"
        >
         {t('global.cancel')}
        </Button>
        <Button
         variant="contained"
         endIcon={<IconCheckWhite style={{ width: 16, height: 11 }} />}
         onClick={() => {
          updateGrid();
         }}
        >
         {t('global.apply')}
        </Button>
       </Box>
      </Box>
     </Box>
    </Box>
   </DialogContent>
  </Dialog>
 );
});
ColModal.displayName = 'ColModal';
export default ColModal;
